import React from 'react';
import { StyledTextField } from './style';

const TextInput = function (props: any) {
  return <StyledTextField variant="outlined" {...props} />;
};

export default TextInput;
